export class Modal {
    constructor() {
        this._modal = document.querySelector('.custom-modal');
        this._modal_inset = null;
        this._modal_content = null;
        this._documentClickHandler = this._documentClickHandler.bind(this);
        this.body = document.body;
        this._init();
    }

    _init() {
        this.createModal();
        document.addEventListener('click', this._documentClickHandler);
    }

    _documentClickHandler(evt) {
        const target = evt.target;

        if (target.closest('[data-modal-close]') && target.closest('[data-modal-open]')) {
            this.closeModal();
            setTimeout(() => {
                this._modal_inset.innerHTML = '';
                this.openModal(target);
            }, 50);

            return;
        }

        if (target.closest('[data-modal-close]')) {
            this.closeModal();

            return;
        } 

        if (target.closest('[data-modal-open]')) {
            evt.preventDefault();
            setTimeout(() => {
                this._modal_inset.innerHTML = '';
                this.openModal(target);
            }, 50);

            return;
        }
    }

    openModal(element) {
        if (document.getElementById(element)) {
            this._modal_content = document.getElementById(element);
        } else {
            const attr = element.closest('[data-modal-open]').getAttribute("data-modal-id");
            this._modal_content = document.getElementById(attr);
        }
        
        this._modal_inset.append(this._modal_content);
        this.modal.classList.add('active');
        this.body.classList.add('scroll-lock');
    }

    closeModal() {
        this.modal.classList.remove('active');
        this.body.append(this._modal_content);
        this.body.classList.remove('scroll-lock');
    }

    createModal() {
        if (!this.modal) {
            this.modal = document.createElement('div');
            this.modal.classList.add('custom-modal');
            document.body.append(this.modal);

            this.modal.innerHTML = `
                <div class="custom-modal__wrapper">
                    <div class="custom-modal__overlay" data-modal-close></div>
                        <div class="custom-modal__content">
                            <div class="custom-modal__inset"></div>
                            <button type="button" class="custom-modal-close" data-modal-close></button>
                        </div>
                </div>   
            `

            this._modal_inset = document.querySelector('.custom-modal__inset');
        }
    }
}